import { gate } from 'hub-http/gates';
export const ALL_PROPERTIES_PANEL = gate('CRM:Records:AllPropertiesPanel');